import _regeneratorRuntime from "@babel/runtime/regenerator";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __asyncValues = this && this.__asyncValues || function (o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator],
      i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
    return this;
  }, i);

  function verb(n) {
    i[n] = o[n] && function (v) {
      return new Promise(function (resolve, reject) {
        v = o[n](v), settle(resolve, reject, v.done, v.value);
      });
    };
  }

  function settle(resolve, reject, d, v) {
    Promise.resolve(v).then(function (v) {
      resolve({
        value: v,
        done: d
      });
    }, reject);
  }
};

import { AsyncSerialScheduler } from "./_scheduler";
import { isAsyncIterator, isIterator } from "./_util";
import Observable from "./observable";
import unsubscribe from "./unsubscribe";
/**
 * Maps the values emitted by another observable. In contrast to `map()`
 * the `mapper` function returns an array of values that will be emitted
 * separately.
 * Use `flatMap()` to map input values to zero, one or multiple output
 * values. To be applied to an input observable using `pipe()`.
 */

function flatMap(mapper) {
  return function (observable) {
    return new Observable(function (observer) {
      var scheduler = new AsyncSerialScheduler(observer);
      var subscription = observable.subscribe({
        complete: function complete() {
          scheduler.complete();
        },
        error: function error(_error) {
          scheduler.error(_error);
        },
        next: function next(input) {
          var _this = this;

          scheduler.schedule(function (next) {
            return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              var e_1, _a, mapped, mapped_1, mapped_1_1, element;

              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return mapper(input);

                    case 2:
                      mapped = _context.sent;

                      if (!(isIterator(mapped) || isAsyncIterator(mapped))) {
                        _context.next = 31;
                        break;
                      }

                      _context.prev = 4;
                      mapped_1 = __asyncValues(mapped);

                    case 6:
                      _context.next = 8;
                      return mapped_1.next();

                    case 8:
                      mapped_1_1 = _context.sent;

                      if (mapped_1_1.done) {
                        _context.next = 14;
                        break;
                      }

                      element = mapped_1_1.value;
                      next(element);

                    case 12:
                      _context.next = 6;
                      break;

                    case 14:
                      _context.next = 19;
                      break;

                    case 16:
                      _context.prev = 16;
                      _context.t0 = _context["catch"](4);
                      e_1 = {
                        error: _context.t0
                      };

                    case 19:
                      _context.prev = 19;
                      _context.prev = 20;

                      if (!(mapped_1_1 && !mapped_1_1.done && (_a = mapped_1.return))) {
                        _context.next = 24;
                        break;
                      }

                      _context.next = 24;
                      return _a.call(mapped_1);

                    case 24:
                      _context.prev = 24;

                      if (!e_1) {
                        _context.next = 27;
                        break;
                      }

                      throw e_1.error;

                    case 27:
                      return _context.finish(24);

                    case 28:
                      return _context.finish(19);

                    case 29:
                      _context.next = 32;
                      break;

                    case 31:
                      mapped.map(function (output) {
                        return next(output);
                      });

                    case 32:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee, null, [[4, 16, 19, 29], [20,, 24, 28]]);
            }));
          });
        }
      });
      return function () {
        return unsubscribe(subscription);
      };
    });
  };
}

export default flatMap;